// Friendly, product-facing display names for the Zaya annotation-import pipelines, overriding the
// raw App Engine task descriptor name wherever a pipeline/task is shown (Pipelines panel + /apps).
// Keyed by task namespace so it survives version bumps.
const PIPELINE_DISPLAY_NAMES = {
  'ai.zaya.pipeline.tbsputum': 'Tuberculosis (TB)',
  'ai.zaya.pipeline.tbtissue': 'Tuberculosis Tissue (TB)',
  'ai.zaya.pipeline.uc': 'Urothelial Carcinoma (UC)',
};

export function pipelineDisplayName(task) {
  if (!task) {
    return '';
  }
  return PIPELINE_DISPLAY_NAMES[task.namespace] || task.name;
}

// True for the Zaya annotation-import pipelines (TB / UC) — these runs are backed by a
// ims-service PipelineRun and insert annotations, so deleting one also deletes those.
export function isAnnotationImportPipeline(task) {
  return !!task && Object.prototype.hasOwnProperty.call(PIPELINE_DISPLAY_NAMES, task.namespace);
}

export default pipelineDisplayName;
